import React, { useState } from "react";
import { FlexContainer, H1Text, Hr, LeftBackButtonText } from "../../design";
import { Tag, Tooltip } from "antd";
import BaseSplitPage from "../../components/splitpage";
import Header from "./smallscreen/header";
import Support from "../../components/support";
import { HomeOutlined, PlusCircleOutlined } from '@ant-design/icons';
import { useEffect } from "react";
import { API } from "../../api";
import { PAGES } from "../../appconstants";

type Props = {
    history: {
        push: Function,
    },
}

const Login = (props: Props) => {
    const [bankData, setBankData] = useState([]);
    const [selected, setSelected] = useState(null);

    useEffect(() => {
      getBankDetails();
      getWalletDetails();
    }, []);

    const getBankDetails = async () => {
        const { data: { entity } } = await API.get(`/rewards/wallet-bank`,
        {
            headers: {
                'RewardsAuthorization': `Bearer ${localStorage.getItem('rtpAccessToken')}`
            },
        });
        if(entity?.content.length > 0){
            setBankData(entity?.content)
        } 
    };
    
    const getWalletDetails = async () => {
        const { data: { entity } } = await API.get(`/rewards/wallet`,
            {
                headers: {
                    'RewardsAuthorization': `Bearer ${localStorage.getItem('rtpAccessToken')}`
                },
            } 
        );
        if(!entity?.walletPin || entity?.walletPin?.status !== 'VERIFIED'){
            props.history.push(PAGES.RTP_WALLET_PIN_SETUP);
        } 
    };

    return (
        <BaseSplitPage left={
            <>
                <FlexContainer
                    flexDirection="column"
                    position="relative"
                    display="block"
                    height="100%"
                >
                    <div>
                        <LeftBackButtonText
                            onClick={() => { props.history.push(PAGES.RTP_REGISTER); }}
                        >
                            Back
                        </LeftBackButtonText>
                        <H1Text>
                            RTP BANK'S
                        </H1Text>
                    </div>
                    <div style={{ position: "sticky", top: "85%" }}>
                        <Support email={null}
                            phone={null} />
                    </div>
                </FlexContainer>
            </>
        } right={
            <>
                <Header payment={null} />
                <FlexContainer
                    className="pt-3 pt-lg-5 w-100 p-2"
                    box-shadow="0 0 15px 0 rgba(0, 0, 0, 0.1)"
                    display="flow-root"
                    backgroundColor="#fff"
                    borderRadius="10px"
                    marginTop="5%"
                    marginBottom="5%"
                >
                    <H1Text
                        className="px-1 px-md-4 mt-4"
                    >
                        RTP BANK'S
                    </H1Text>
                    <Hr />
                    <div className="mt-4">
                        <FlexContainer flexDirection="column">
                        <div
                            style={{
                                width: 320,
                                border: "1px solid #e0e0e0",
                                borderRadius: 16,
                                padding: 16,
                                backgroundColor: "#fff",
                                boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                                fontFamily: "Arial, sans-serif",
                            }}
                        >
                        {/* Header */}
                            <div
                                style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                marginBottom: 16,
                                }}
                            >
                                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                <HomeOutlined style={{ fontSize: '20px', color:"#1677ff", }}/>
                                <span style={{ fontSize: 16, fontWeight: 500, color: "#333" }}>
                                    Bank Account
                                </span>
                                </div>
                                <Tooltip title="Create New Bank">
                                  <PlusCircleOutlined style={{ cursor: "pointer", color:"#1677ff", fontSize: '20px' }}
                                    onClick={() => props.history.replace(PAGES.RTP_BANK_ACCOUNT_SETUP)}
                                  />
                                </Tooltip>
                            </div>
                            {/* Account Box */}
                            {bankData.length > 0 && bankData.map((item, index) => (
                            <>
                            <div key={index}
                                style={{
                                border: "1px solid #e0e0e0",
                                borderRadius: 12,
                                padding: 12,
                                backgroundColor: selected?.indexNum === index ? "#f9f9f9" : "#ffffff",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "flex-start",
                                marginBottom: 16,
                                marginTop: index > 0 ? 16 : 0,
                                cursor: item?.applePkPassDownloadUrl ? 'pointer' : 'not-allowed'
                                }}
                                onClick={() => {
                                    if (item?.applePkPassDownloadUrl) {
                                    setSelected({ indexNum: index, gid: item?.gid });
                                    }
                                }}
                            >
                                <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                    <span style={{ fontWeight: 500, color: "#333" }}>
                                      {`**** ${item?.lastFour}`} {item?.isDefault === true ? <Tag color="green">Default Bank</Tag> : ''}
                                    </span>
                                </div>
                                </div>
                                {selected?.indexNum === index && (
                                    <input
                                      type="checkbox"
                                      checked
                                      readOnly
                                      style={{ marginTop: 4, accentColor: "#1677ff" }}
                                  />
                                )}
                            </div>
                            </>
                            ))}
                            {/* Go to Pay Button */}
                            <button
                                style={{
                                width: "100%",
                                backgroundColor: selected?.gid ? "#1677ff" : "#d6d6d6",
                                color: "#fff",
                                fontWeight: 600,
                                padding: "10px 0",
                                border: "none",
                                borderRadius: 12,
                                cursor: selected?.gid ? "pointer" : "not-allowed",
                                fontSize: 14,
                                }}
                                onClick={() => {
                                    if (selected && selected?.gid) {
                                    props.history.push(`/rtp-payment-link?gid=${selected?.gid}`);
                                }}}
                            >
                                Go to Pay
                            </button>
                            </div>
                        </FlexContainer>
                    </div>
                </FlexContainer>
            </>
        } />
    )
};

export default Login;
